module.exports = __webpack_public_path__ + "static/media/14.a5f36082.jpg";